import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box } from '@mui/material';
import type { StructuredContentDocument } from '@repo/supergraph-schemas/structuredContent/types';
import { StructuredContentRenderer } from '../..';

type Props = StructuredContentDocument<{
  children: StructuredContentDocument;
}>;

export function BankingAttentionNote({ props }: Props) {
  const { children } = props;
  return (
    <Box
      data-testid="attention-note-component"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: 3,
        backgroundColor: '#FFFBEB',
        border: '1px solid',
        borderColor: 'yellows.lighter',
        borderRadius: 2,
      }}
    >
      <InfoOutlinedIcon sx={{ color: '#5F6368', fontSize: '24px', transform: 'rotate(180deg)' }} />
      <Box sx={{ '& p': { fontSize: '13px' } }}>
        <StructuredContentRenderer doc={children} />
      </Box>
    </Box>
  );
}
